// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9f07fafd","785":"6b9cb655"}[chunkId] + ".chunk.js";
};